import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';

Swiper.use([Navigation, Pagination]);

new Swiper('.vacancies-slider', {
    slidesPerView: 1,
    spaceBetween: 5,
    loop: true,
    autoplay: {
        delay: 5000,
    },
    navigation: {
        nextEl: '.vacancies-next',
        prevEl: '.vacancies-prev',
    },
    
    breakpoints: {
        368: {
            slidesPerView: 1,
        },
        769: {
            slidesPerView: 2,
        },
        1025: {
            slidesPerView: 3,
        },
        1440: {
            slidesPerView: 4,
        },
    }
});

new Swiper('.reviews-slider', {
    slidesPerView: 1.4,
    centeredSlides: true,
    centeredSlidesBounds: true,
    spaceBetween: 7,
    loop: true,
    autoplay: {
        delay: 5000,
    },
    navigation: {
        nextEl: '.reviews-next',
        prevEl: '.reviews-prev',
    },
    
    breakpoints: {
        769: {
            slidesPerView: 1.8,
        },
        1025: {
            slidesPerView: 2.2,
        },
        1440: {
            slidesPerView: 2.8,
        },
    }
});